"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CellWrapper = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */
const react_1 = __importDefault(require("react"));
const cellWrapper_css_1 = require("./cellWrapper.css");
const CellWrapper = ({ children, row, column }) => {
    const testId = `fds-table-cell-wrapper-${column.id}-${row.id}`;
    return react_1.default.createElement("div", { className: cellWrapper_css_1.container, "data-test-id": testId }, children);
};
exports.CellWrapper = CellWrapper;
